import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ChefsHatIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21 16.346",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 16.346),
    children: [/*#__PURE__*/jsx("path", {
      d: "m16.333 2.982a4.135 4.135 0 0 0 -1.389.254 4.978 4.978 0 0 0 -8.889 0 4.138 4.138 0 1 0 -1.389 8.026v1.982h11.667v-1.982a4.14 4.14 0 1 0 0-8.28z"
    }), /*#__PURE__*/jsx("path", {
      d: "m4.658 13.229h11.669v2.325c0 .161-.317.291-.707.291h-10.255c-.391 0-.707-.13-.707-.291z"
    }), /*#__PURE__*/jsx("path", {
      d: "m7.841 15.212v.442"
    }), /*#__PURE__*/jsx("path", {
      d: "m10.493 15.212v.442"
    }), /*#__PURE__*/jsx("path", {
      d: "m13.145 15.212v.442"
    })]
  });
};

export { PM2ChefsHatIcon };
//# sourceMappingURL=chefs-hat.js.map
